module.exports = __webpack_public_path__ + "img/digi-crush-7.4a6cb101.png";